import React from 'react';
import { TextInput } from 'react-native';
const ProductInput = (props) => {
  const { value, editable, onChangeText, onSubmitEditing, style, id } = props
  return (
    <TextInput
      testID={id}
      value={value}
      onChangeText={(text, name) => onChangeText(text, name)}
      onSubmitEditing={onSubmitEditing}
      editable={editable}
      style={style}
    />
  )
}
export default ProductInput